import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { API_URL } from '../../config.js';

const API = API_URL;

const AdminLogin = () => {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('ihn_admin_token');
    if (token) verifyToken(token);
  }, []);

  const verifyToken = async (token) => {
    try {
      const res = await fetch(`${API}/admin/verify`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) navigate('/admin/dashboard', { replace: true });
      else localStorage.removeItem('ihn_admin_token');
    } catch {
      localStorage.removeItem('ihn_admin_token');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), password }),
      });

      const data = await res.json();

      if (data.success && data.token) {
        localStorage.setItem('ihn_admin_token', data.token);
        navigate('/admin/dashboard', { replace: true });
      } else {
        setError(data.message || 'Invalid credentials');
      }
    } catch {
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center',
      background: 'radial-gradient(circle at top, #fdf7ff 0%, #f3f0ff 40%, #e5e0ff 100%)',
      padding: '24px',
    }}>
      <div style={{
        width: '100%', maxWidth: 460, background: '#ffffff',
        borderRadius: 24, boxShadow: '0 24px 80px rgba(44, 27, 99, 0.12)',
        padding: '36px 32px',
      }}>
        <h1 style={{ margin: '0 0 16px', fontSize: '28px', color: '#1f2a49', fontWeight: 800 }}>
          Admin Login
        </h1>
        <p style={{ margin: '0 0 24px', color: '#5b6376', lineHeight: 1.6 }}>
          Enter your admin credentials to access the IHN admin panel.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', marginBottom: 18, color: '#4b5269', fontWeight: 700 }}>
            Email
            <input
              type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter admin email"
              autoComplete="email"
              style={{
                width: '100%', marginTop: 8, padding: '14px 16px',
                borderRadius: 14, border: '1px solid #d8dbe8',
                fontSize: 15, outline: 'none', boxSizing: 'border-box',
              }}
              required
            />
          </label>

          <label style={{ display: 'block', marginBottom: 24, color: '#4b5269', fontWeight: 700 }}>
            Password
            <input
              type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              autoComplete="current-password"
              style={{
                width: '100%', marginTop: 8, padding: '14px 16px',
                borderRadius: 14, border: '1px solid #d8dbe8',
                fontSize: 15, outline: 'none', boxSizing: 'border-box',
              }}
              required
            />
          </label>

          {error && (
            <div style={{ marginBottom: 18, color: '#c53030', fontWeight: 600 }}>
              ⚠ {error}
            </div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '14px 16px', borderRadius: 14,
              border: 'none', background: '#6b46c1', color: '#fff',
              fontSize: 15, fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 14px 30px rgba(107, 70, 193, 0.22)',
            }}
          >
            {loading ? 'Checking…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;